/**
 * Pave API
 * Pave API Documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Address { 
    lat: number;
    long: number;
    geofenceRadius: number | null;
    text?: string;
    fullAddress?: string;
    zipCode?: string;
    /**
     * Can be set to override the default possible commute detection radius stored in config.POSSIBLE_COMMUTE.MAX_RADIUS_IN_METERS  This is especially useful for work locations within big cities
     */
    possibleCommuteDetectionGeofenceRadiusInMeters?: number;
}

